export enum swRatPreferenceEnum {
    /**
	 * Unknown network.
	 */
	LE_MRC_BITMASK_UNKNOWN,
	/**
	 * GSM network.
	 */
	LE_MRC_BITMASK_RAT_GSM,
	/**
	 * UMTS networks.
	 */
	LE_MRC_BITMASK_RAT_UMTS,
	/**
	 * TD-SCDMA networks.
	 */
	LE_MRC_BITMASK_RAT_TDSCDMA,
	/**
	 * LTE network.
	 */
	LE_MRC_BITMASK_RAT_LTE,
	/**
	 * CDMA network.
	 */
	LE_MRC_BITMASK_RAT_CDMA,
	/**
	 * All networks.
	 */
	LE_MRC_BITMASK_RAT_ALL
}